import React from 'react';
import { formatFieldName } from '../../utils/formatters';

const ReasonsSection = ({ reasons }) => {
    if (!reasons || Object.keys(reasons).length === 0) {
        return null;
    }

    return (
        <div>
            <h4 style={{ marginBottom: '15px', color: '#e0e0e0', fontWeight: '600' }}>Model Reasoning</h4>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
                {Object.entries(reasons).map(([field, reason]) => (
                    <div 
                        key={field}
                        style={{
                            backgroundColor: '#2d2d2d',
                            border: '1px solid #404040',
                            borderRadius: '6px',
                            padding: '15px'
                        }}
                    >
                        <div style={{ 
                            fontSize: '14px',
                            fontWeight: '600',
                            color: '#b8b8b8',
                            marginBottom: '8px'
                        }}>
                            {formatFieldName(field)}
                        </div>
                        <p style={{ 
                            margin: 0,
                            color: '#d0d0d0',
                            lineHeight: '1.6',
                            fontSize: '14px'
                        }}>
                            {reason}
                        </p>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ReasonsSection;


